import PageLayout from 'components/layouts/PageLayout';
import SectionLayout from 'components/layouts/SectionLayout';
import React, { useEffect } from 'react';
import PriceQuoteContent from './content/PriceQuoteContent';

function PriceQuote() {

    useEffect(() => {
        // Change Tab Title
        document.title = "Price Quote - Insurance Enterprise"
    }, [])

    return (
        <>
            <PageLayout
                content={
                    <>
                        <SectionLayout content={<PriceQuoteContent />} />
                    </>
                }
            />
        </>
    )
}

export default PriceQuote
